module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kc-Ld.71225d98.png";